module.exports = __webpack_public_path__ + "img/3_106.fe5039b7.png";